import { render } from "./RecapitulatifPage.vue?vue&type=template&id=3c21bfd2&ts=true"
import script from "./RecapitulatifPage.vue?vue&type=script&lang=ts"
export * from "./RecapitulatifPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__